"use strict";
exports.__esModule = true;
exports.chart_global_layout_Padding = {
  "name": "--pf-chart-global--layout--Padding",
  "value": 50,
  "var": "var(--pf-chart-global--layout--Padding, 50)"
};
exports["default"] = exports.chart_global_layout_Padding;